import moment from 'moment';
import { competitionWhenWhere } from './competitionWhenWhere';

/**
 * «[DEMO] Чемпіонат … · 16.11 – 18.11.2026 · Черкаси · MSAC (за 11 днів)» —
 * a competition as the applications screen names it: its title, when and
 * where (1 Nov 2026: «якщо пишемо назву змагань, то треба писати, коли воно
 * відбувається»), and how long applications stay open. `fullInfo` is kept
 * for its callers; both now say the same.
 */
export const competitionInfoLine = (competition = {}, fullInfo = false) => { // eslint-disable-line no-unused-vars
    const { title, openForApplicationTill } = competition;
    const whenWhere = competitionWhenWhere(competition);
    const until = openForApplicationTill ? ' (' + moment(openForApplicationTill).fromNow() + ')' : '';

    return [title, whenWhere].filter(Boolean).join(' · ') + until;
};
